import { configureStore } from "@reduxjs/toolkit";
import modalStore from "../redux/modalStore";

export default configureStore({
  reducer: {
    modal: modalStore,
  },
});
